var map = {
	"./UiStrings": [
		19118,
		7463
	],
	"./UiStrings.ts": [
		19118,
		7463
	],
	"./UiStringsAr": [
		97386,
		7386
	],
	"./UiStringsAr.ts": [
		97386,
		7386
	],
	"./UiStringsEn": [
		32184
	],
	"./UiStringsEn.ts": [
		32184
	],
	"./UiStringsEs": [
		14732,
		4732
	],
	"./UiStringsEs.ts": [
		14732,
		4732
	],
	"./UiStringsRu": [
		77655,
		7655
	],
	"./UiStringsRu.ts": [
		77655,
		7655
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 75480;
module.exports = webpackAsyncContext;